import InTransitJobs from './styled';

export default InTransitJobs;
